import { LoadingIndicator } from "components/atoms/LoadingIndicator";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import useTranslation from "next-translate/useTranslation";
import React, { Suspense, VFC } from "react";
import { useTopics } from "~/iterators/firestore/topics/useTopics";
import { getCurrentProjectId } from "~/lib/utils/urlHelper";
import Layout from "faqSrc/components/layout/Layout";
import { MetaTag } from "faqSrc/components/modules/metaTag";
// use lazy load to resolve React Hydration Error
const QuestionTopicPresenter = dynamic(
  () =>
    import("faqSrc/components/templates/questions/post/topic/topicPresenter"),
  { loading: () => <LoadingIndicator />, ssr: false }
);

interface Props {
  refererUrl?: string;
}

const TemplateQuestionTopic: VFC<Props> = ({ refererUrl }) => {
  const { t } = useTranslation();
  return (
    <Layout hideHeader>
      <>
        <MetaTag
          isNoIndexPage={true}
          title={t("frontPage:question.post.topic.meta-title")}
        />
        <Suspense fallback={<></>}>
          <QuestionTopic refererUrl={refererUrl} />
        </Suspense>
      </>
    </Layout>
  );
};

const QuestionTopic: VFC<Props> = ({ refererUrl }) => {
  const router = useRouter();
  const { requestedUserName, requestedUserId } = router.query;
  const { topics } = useTopics({ projectId: getCurrentProjectId() });

  return (
    <QuestionTopicPresenter
      topics={topics}
      refererUrl={refererUrl}
      requestedUserId={requestedUserId as string}
      requestedUserName={requestedUserName as string}
    />
  );
};

export default TemplateQuestionTopic;
